import { useEffect, useMemo, useReducer, useRef, useState } from 'react';
import React from 'react';
import ReactDataGrid from 'react-data-grid';
import CellExpanderFormatter from '../Billing/Claims/ClaimDetails/CellExpandFormatter';
import { ServerRequestProtected } from '../../utils/ServerDataRequest';
import { enumUtil } from '../../utils/Enum';
import Loader from '../shared/Loader/Loader';
import GridColumnHeader from '../Setup/Shared/GridColumnHeader';
import { Modal, ModalBody } from 'react-bootstrap';
import SuperSearchList from '../shared/SuperSearch/SuperSearchList';
import isNull from '../../utils/NullChecking';
const AuditDetailedColumns = [
    { key: 'AuditDate', name: 'Audit Date', width: 140, resizable: true, },
    {
        key: 'ColumnName', name: 'Name', width: 200, renderCell: ({ row }) => {
            return (
                <div className="validation_message" title={row.ColumnName}>{row.ColumnName}</div>
            );
        },
        resizable: true,
    },
    { key: 'BeforeUpdateValue', name: 'Before', width: 100, resizable: true, renderCell: ({ row }) => { return <div className='validation_message' title={row.BeforeUpdateValue}>{row.BeforeUpdateValue}</div> } },
    { key: 'AfterUpdateValue', name: 'After ', width: 85, resizable: true, renderCell: ({ row }) => { return <div className='validation_message' title={row.AfterUpdateValue}>{row.AfterUpdateValue}</div> } },
    { key: 'AuditBy', resizable: true, name: 'Audit By' },
];
// let AuditDetailedData = [];
// let AuditDetails = []
const Audit = (props) => {
    const ClaimDD = [
        { value: 'All', display: 'All' },
        { value: 'Claim', display: 'Claim' },
        { value: 'Insurance', display: 'Insurance' },
        { value: 'Diagnosis', display: 'Diagnosis' }
    ]
    const API_URL = enumUtil.controller.Audit
    const { isOpenAudit, onCloseAudit, ParentID, TableName, type } = { ...props }
    const [isAllSelected, setIsAllSelected] = useState(false)
    const [DisplayWise, setDisplayWise] = useState(true)
    const [isLoading, setisLoading] = useState(false)
    const [allRows, setallRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [param, setParam] = useState('');
    const [is, setIs] = useState(false)
    const [auditDetails, setAuditDetails] = useState([]);
    const [selectType, setSelectType] = useState({
        display: ClaimDD[0].display,
        value: ClaimDD[0].value
    })
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    const columns = useMemo(() => {
        return [
            {
                key: 'expanded',
                name: '',
                minWidth: 30,
                width: 30,
                colSpan(args) {
                    return args.type === 'ROW' && args.row.type === 'DETAIL' ? 3 : undefined;
                },
                cellClass(row) {
                    return row.type === 'DETAIL'
                        ?
                        " padding: 24px;"

                        : undefined;
                },
                renderCell({ row, isCellSelected, onRowChange, tabIndex }) {
                    if (row.type === 'DETAIL') {
                        return (
                            <DetailedGrid
                                isCellSelected={isCellSelected}
                                detailData={row.detailData}
                            // parentId= {row.parentId}
                            // direction= {direction} 
                            />
                        );
                    }
                    return (
                        <CellExpanderFormatter
                            expanded={row.expanded}
                            isCellSelected={isCellSelected}
                            onCellExpand={() => {
                                onRowChange(Object.assign(Object.assign({}, row), { expanded: !row.expanded }));
                            }}
                            tabIndex={tabIndex}
                        />
                    );
                }
            },
            // { key: 'ID', name: 'ID', width: 50},
            {
                key: 'AuditDate',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-card'} headerName={'Audit Date'} sortIcon={false} type={'string'} colKey={'AuditDate'} data={rows} setData={setRows} />),
                width: isAllSelected ? 133 : 620.8,
                resizable: true
            }
        ];
    }, []);
    const LoadData = () => {
        setisLoading(true)
        let url = API_URL + "/FindAuditDateWise";
        let tableName = TableName;
        let payload = {
            ID: ParentID,
            TableName: TableName,
            SearchParam: param
        };
        if (type === 'Claim') {
            url = API_URL + "/FindAuditDateWise";
            tableName = "Claim  ";

            payload = {
                ID: ParentID,
                TableName: selectType.value === 'Claim' ? 'Claim'
                    : selectType.value === 'Insurance' ? 'ClaimInsurance'
                        : selectType.value === 'Diagnosis' ? 'ClaimDiagnosis'
                            : selectType.value === 'All' ? 'Claim'
                                : 'Claim',
                // TableName: tableName,
                SearchParam: param,
                Data: {
                    type: selectType.value,
                }
            };
        }

        ServerRequestProtected(url, 'post', payload)
            .then((response) => {
                setisLoading(false)
                setallRows(response.AuditDetails)
                handleGridHeader({ defaultData: response.AuditDetails })
                const newRows = response.AuditDate.map(row => ({
                    ...row,
                    type: 'MASTER',
                    expanded: false,
                }));
                setAuditDetails(response.AuditDetails); // ✅ state instead of module var
                // AuditDetails = response.AuditDetails
                setRows(newRows);

            }).catch((error) => {
                setisLoading(false)
                console.log(error);
            })
    }
    const columnsAll = [
        {
            key: 'AuditDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'AuditDate'} sortIcon={true} type={'string'} colKey={'AuditDate'} data={allRows} setData={setallRows} />),
            width: 150,
            resizable: true,
        },
        {
            key: 'ColumnName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Name'} sortIcon={true} type={'string'} colKey={'ColumnName'} data={allRows} setData={setallRows} />),
            width: 130,
            resizable: true,
        },
        {
            key: 'BeforeUpdateValue',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Before'} sortIcon={true} type={'string'} colKey={'BeforeUpdateValue'} data={allRows} setData={setallRows} />),
            resizable: true,
        },
        {
            key: 'AfterUpdateValue',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'After'} sortIcon={true} type={'string'} colKey={'AfterUpdateValue'} data={allRows} setData={setallRows} />),
            resizable: true,
        },
        {
            key: 'AuditBy',
            name: 'Audit By',
            resizable: true,
        },
    ]
    const findRecord = (date, details) => {
        const dateOnly = date.split(" ")[0];
        return details.filter(item => {
            let itemDate = item.AuditDate.split(" ")[0];
            return itemDate === dateOnly;
        });
    }
    useEffect(() => {
        LoadData();
    }, [selectType.value])
    function onRowsChange(rows, { indexes }) {
        const row = rows[indexes[0]];
        if (row.type === 'MASTER') {
            if (!row.expanded) {
                rows.splice(indexes[0] + 1, 1);
            }
            else {
                const detailData = findRecord(row.AuditDate, auditDetails);
                rows.splice(indexes[0] + 1, 0, {
                    type: 'DETAIL',
                    id: row.ID,
                    parentId: row.ID,
                    detailData
                });
            }
            setRows(rows);
            // findRecord(row.AuditDate, AuditDetails)
        }
    }
    const handleDispayWise = () => {
        setIsAllSelected(false)
        setDisplayWise(!DisplayWise)
    }
    const handleIsAllSelected = () => {
        setDisplayWise(false)
        setIsAllSelected(!isAllSelected)
    }
    const handleAuditSearch = () => {
        LoadData()
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setParam(e.target.value)
            LoadData()
        }
    }
    const getRowHeight = (row) => {
        if (row.type === 'DETAIL') {
            const count = row.detailData?.length || 0;  // ✅
            const heights = { 1: 56, 2: 81, 3: 106, 4: 131 };
            if (count >= 5) return 156;
            return heights[count] ?? 56;
        }
        return 25;
    };

    const handleSelectedData = (selectedData, name, type) => {
        setIs(true)
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'SelectType') {

                setSelectType({ ...selectType, display: selectedData.display, value: selectedData.value })
            }


        } else {
        }
        return selectedData
    }
    const handleChange = (e) => {
        setIs(false)
        let { name, value } = e.target
        if (name === 'SelectType') {
            setSelectType({ ...selectType, display: value, })
        }
    }
    return (
        <>
            <Modal show={isOpenAudit} onHide={onCloseAudit} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_audit-modal">
                {isLoading ? <Loader /> : null}

                {/* <div className='d-flex justify-content-between align-items-center px-10 pt-15 pb-2 ar-light  br-bottom-1'>
                        <p className="heading fs-14">Data Audit</p>
                        <i className='icon-Icon-metro-cross' onClick={onCloseAudit}></i>
                    </div> */}

                <div className="d-flex justify-content-between align-items-center px-10 pt-15 pb-2 ar-light  br-bottom-1">
                    <div className="">
                        <p className="heading fs-14 dark-clr">Data Audit</p>
                    </div>
                    <i className="icon-x-cros fs-20 dark-clr" onClick={onCloseAudit}></i>
                </div>
                <ModalBody>
                    <div className="bg-transparent border-0 hk-popper position-static shadow-none w-100">
                        <div className='hk-TopHeader d-flex justify-content-between align-items-center px-10 py-2 no-round-right '>
                            <div className="form-rounded ar-poper-searchbar">
                                <div className="input">
                                    <div className='input-group hk-input-search'>
                                        <input type="text" className='form-control fc-xs'
                                            placeholder='Search' onChange={(e) => setParam(e.target.value)} onKeyDown={SearchOnEnter}
                                        />
                                        <span className="input-group-text" id="basic-addon2" onClick={handleAuditSearch}>
                                            <i className="bi bi-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex gap-10">

                                <div className="ar_radio-btn d-flex align-items-center gap-1">
                                    <input
                                        type="radio"
                                        name="display"
                                        id="DayWise"
                                        value="DayWise"
                                        checked={DisplayWise}
                                        onChange={handleDispayWise}
                                    />
                                    <p htmlFor="DayWise" className="text fs-12 ar-orange-text" >Display Day wise</p>
                                </div>
                                <div className="ar_radio-btn d-flex align-items-center gap-1">
                                    <input
                                        type="radio"
                                        name="display"
                                        id="All"
                                        alue="All"
                                        checked={isAllSelected}
                                        onChange={handleIsAllSelected}
                                    />
                                    <p htmlFor="All" className="text fs-12 ar-orange-text" >All</p>
                                </div>
                            </div>
                        </div>
                        <div className={`blue-header d-flex align-items-center justify-content-between ${type === 'Claim' ? 'h-100 py-1' : ''}`}>
                            <p className='heading validate-color'>Audit Date</p>
                            {type === 'Claim' ? <div className='position-relative form-group input'>
                                {/* <label>Ordering Provider</label> */}
                                <SuperSearchList
                                    type="client"
                                    id='SelectType'
                                    name='SelectType'
                                    searchValue={selectType?.display}
                                    data={ClaimDD}
                                    onChange={handleChange}
                                    getSelectedData={handleSelectedData}
                                    // is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                // isReadOnly={isReadOnly}
                                // placeholder={false}
                                // disabled={isReadOnly ? true : false}
                                />
                            </div>
                                : null}

                        </div>
                        <div className="row m-0">
                            {isAllSelected ?
                                <div className="px-10 pb-15">
                                    <ReactDataGrid
                                        columns={columnsAll}
                                        rows={allRows}
                                        className="all_audit fill-grid DataGrid-Table ar-audit-grid-styling"
                                        headerRowHeight={25}
                                        rowHeight={getRowHeight}
                                    />
                                </div>
                                :
                                <div className='px-10 pb-15'>
                                    <ReactDataGrid
                                        // rowKeyGetter={rowKeyGetter}
                                        columns={columns}
                                        rows={rows}
                                        onRowsChange={onRowsChange}
                                        headerRowHeight={28}
                                        rowHeight={getRowHeight}
                                        className="fill-grid DataGrid-Table ar-audit-grid-styling"
                                        enableVirtualization={false}
                                        // direction= {direction} 
                                        style={{ userSelect: 'text', height: '430px' }}
                                    // onCellKeyDown={ (_, event) => {
                                    //     if (event.isDefaultPrevented()) {
                                    //         // skip parent grid keyboard navigation if nested grid handled it
                                    //         event.preventGridDefault()
                                    //       }
                                    //     }}
                                    />
                                </div>

                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default Audit
function DetailedGrid({ isCellSelected, detailData }) {
    // const gridRef = useRef(null);
    useEffect(() => {
        if (!isCellSelected)
            return;
        // gridRef
        //     .current.element.querySelector('[tabindex="0"]')
        //     .focus({ preventScroll: true });
    }, [isCellSelected]);
    return (
        <ReactDataGrid
            // ref= {gridRef} 
            // rows={AuditDetailedData}
            rows={detailData ?? []}
            columns={AuditDetailedColumns}
            // rowKeyGetter= {rowKeyGetter}
            style={{ blockSize: 100 }}
            rowHeight={25}
            // direction= {direction} 
            className={'popper-detailed-table claim_inner_grid'}
        />
    );
}
//   function rowKeyGetter(row) {
//     return row.ID;
//   }
